import { Box, ButtonProps, IconButton, ModBox } from '@jfs/ui-new'
import { FC } from 'react'
import { dataExport } from '../../data'
import { useStores } from '../../data/store'
import { Colors } from '../../utils'
import { ActionMenuSearchBy } from '../ActionMenuSearchBy'
import { ButtonNew } from '../AdminButton'
import { DateTabs } from '../DateTabs/DateTabs'
import { DropdownOptimised } from '../DropdownNew'
import { DropdownTypes } from '../DropdownNew/types'
import PaginationController from '../PaginationController/PaginationController'
import { SearchByEntityId } from './SearchByEntityId'
import { SearchByMid } from './SearchByMid'
import { styles } from './styles'

export const actionMenuStrings = {
  today: 'Today',
  customDate: 'Custom Range/Date',
  excel: 'Excel',
  string: 'string',
  lastSeven: 'Last 7 Days',
  lastFifteen: 'Last 15 Days',
  lastThirty: 'Last 30 Days',
  lastNinty: 'Last 90 Days',
  labelGenerate: 'Generate Report',
  export: 'Export',
  refundCancel: 'refund-cancel',
  labelRefundCancel: 'Refund/Cancel Transaction',
  sortBy: 'Sortby',
  thisWeek: 'This Week',
  thisMonth: 'This Month',
}

export interface DateType {
  fromDate: Date
  toDate?: Date
  position?: { left: number; top: number; visible: boolean }
}

export const getDropdowntype = () => {
  const calendarModalType = DropdownTypes.DEFAULT_WITH_IMAGE
  const exportModalType = DropdownTypes.RADIO_BUTTON
  const downloadReportModalType = DropdownTypes.DEFAULT_DOWNLOAD_REPORT
  return { calendarModalType, exportModalType, downloadReportModalType }
}

interface props {
  fetchDataOnChange?: () => void
  filterVisible?: boolean
  setFilterVisible?: (isVisible: boolean) => void
  showSearch: boolean
  enableFilter: boolean
  showCalendar: boolean
  filterApplied?: boolean
  defaultPage?: number
  showExport?: boolean
  handleExport?: any
  type?:
    | 'global'
    | 'checker'
    | 'maker'
    | 'fiuGlobal'
    | 'fiuMaker'
    | 'aadharRedactionMaker'
    | 'aadharRedactionChecker'
    | 'postRecon'
    | 'updatepayoutcms'
    | 'riskconfig'
    | 'RISK_HOLD'
  showPagination?: boolean
  searchByInitialVal?: string
  showSearchByMid?: boolean
  onSearchByMidClick?: any
  initialSearchMid?: any
  onMidChange?: any
  maxRange?: any
  showSearchByEntityId?: any
  onSearchByEntityIdClick?: any
  initialSearchByEntityIdValue?: any
  showSearchByCrossButton?: any
  showSearchByLoader?: any
  showRefresh?: any
  onRefresh?: any
  searchByEntityIdPlaceholder?: any
  showAdditionalButton?: boolean
  additionalButtonProps?: ButtonProps
}

const ActionsMenu: FC<props> = ({
  fetchDataOnChange,
  filterVisible = false,
  setFilterVisible,
  showSearch,
  enableFilter,
  showCalendar,
  filterApplied,
  defaultPage = 0,
  type,
  showPagination = true,
  showExport = false,
  handleExport,
  searchByInitialVal = '',
  showSearchByMid = false,
  onSearchByMidClick,
  initialSearchMid,
  onMidChange,
  maxRange,
  showSearchByEntityId = false,
  onSearchByEntityIdClick,
  initialSearchByEntityIdValue,
  showSearchByCrossButton,
  showSearchByLoader,
  showRefresh = false,
  onRefresh,
  searchByEntityIdPlaceholder,
  showAdditionalButton = false,
  additionalButtonProps,
}: props) => {
  const { updatePagination, paginationData, resetPagination, updateSelectedDate, selectedDateInfo, showHideCalendar } =
    useStores((root) => ({
      updatePagination: root?.updatePagination,
      paginationData: root?.pagination,
      resetPagination: root?.resetPagination,
      updateSelectedDate: root?.updateSelectedDateInfo,
      selectedDateInfo: root.selectedDateInfo,
      showHideCalendar: root.selectedDateInfo.position.visible,
    }))

  const onDateTabs = (fromDate: Date, toDate: Date) => {
    resetPagination()
    updateSelectedDate({
      ...selectedDateInfo,
      fromDate,
      toDate,
    })
    if (fetchDataOnChange) {
      console.log('===> onDateTabs called fetchDataOnChange', fromDate, toDate)
      fetchDataOnChange()
    }
  }

  const handlePagination = (selectedPage: number) => {
    console.log('===> handlePagination', selectedPage)
    updatePagination(selectedPage)
    if (fetchDataOnChange) {
      console.log('===> handlePagination called fetchDataOnChange', selectedPage)
      fetchDataOnChange()
    }
  }

  const setMessage = () => {}

  const toggleFilterVisibility = () => {
    setFilterVisible && setFilterVisible(!filterVisible)
  }

  return (
    <Box {...styles.topBar}>
      <ModBox flexDirection="row">
        <ModBox show={showCalendar} flexDirection="row">
          <DateTabs
            onDateSelector={onDateTabs}
            disabled={false}
            sendError={setMessage}
            updateSelectedDate={updateSelectedDate}
            selectedDateInfo={selectedDateInfo}
            type={type}
            maxRange={maxRange ? maxRange : type === 'postRecon' ? 3 : type === 'riskconfig' ? 30 : undefined}
          />
        </ModBox>
        <ModBox show={showSearch} marginLeft={16} height={30}>
          <ActionMenuSearchBy type={type} intialVal={searchByInitialVal} />
        </ModBox>
        <ModBox show={showSearchByMid} marginLeft={16} height={30}>
          <SearchByMid onClick={onSearchByMidClick} initialSearchMid={initialSearchMid} onMidChange={onMidChange} />
        </ModBox>
        <ModBox show={showSearchByEntityId} marginLeft={16} height={30}>
          <SearchByEntityId
            onSearchByEntityIdClick={onSearchByEntityIdClick}
            showSearchByCrossButton={showSearchByCrossButton}
            showSearchByLoader={showSearchByLoader}
            searchByEntityIdPlaceholder={searchByEntityIdPlaceholder}
          />
        </ModBox>
        <ModBox show={showRefresh} marginLeft={16} height={30}>
          <IconButton id="ICON_REFRESH" color="PRIMARY" size={28} onPress={onRefresh} />
        </ModBox>
        <ModBox show={showExport} marginLeft={16}>
          <DropdownOptimised
            testID="exportDropDown"
            placeHolder={actionMenuStrings.export}
            data={dataExport}
            onButtonPress={(fileType) => handleExport(fileType)}
            type={DropdownTypes.RADIO_BUTTON}
            onChange={() => {}}
          />
        </ModBox>
      </ModBox>
      <ModBox direction="row" alignItems={'center'} show={showPagination}>
        <PaginationController
          currentPage={paginationData?.number ?? 0}
          totalPages={paginationData?.totalPages ?? 0}
          totalDataLength={paginationData?.totalElements ?? 0}
          dataSetSize={10}
          onSelect={handlePagination}
          isZeroIndex={false}
          defaultPage={defaultPage}
        />
        <ModBox marginLeft={16} show={enableFilter}>
          <ButtonNew
            onPress={toggleFilterVisibility}
            title={'Filters'}
            hide={false}
            type={'custom'}
            textType={'body12'}
            borderWidth={'1'}
            borderColor={filterVisible ? Colors.BLUE_80 : Colors.DISABLED_GREY}
            color={filterVisible ? Colors.BLUE_0A : Colors.WHITE}
            borderRadius={'5px'}
            hoverColor={'BRAND_COLOR_GRAY_6'}
            underlayColor={'BRAND_COLOR_GRAY_5'}
            icon={'FILTER'}
            titleColor={'BLACK'}
            enableDot={filterApplied}
          />
        </ModBox>
        <ModBox marginLeft={24} show={showAdditionalButton}>
          <ButtonNew {...additionalButtonProps} />
        </ModBox>
      </ModBox>
    </Box>
  )
}

export default ActionsMenu
